module.exports = __webpack_public_path__ + "img/other.ea9b36d4.png";